import Equipe from "./Equipe";

export default class Despesa {
  constructor(id, descricao, data, valor, responsavel) {
    this.id = id;
    this.descricao = descricao;
    this.data = data;
    this.valor = valor;
    this.responsavel = responsavel;
    this.equipe = new Equipe(0, "", "", new Date(), "");
  }

  update(despesa) {
    this.id = despesa.id;
    this.descricao = despesa.descricao;
    this.data = despesa.data;
    this.valor = this.getCurrency(despesa.valor);
    this.responsavel = despesa.responsavel;
    this.equipe = despesa.equipe;
  }

  getCurrency(valor) {
    valor = parseFloat(valor).toFixed(2);
    var inteira = valor.substr(0, valor.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = valor.substr(valor.length - 3, valor.length);
    decimal = decimal.replace(".", ",");
    return "R$ " + ajuste + decimal;
  }

  setNumber() {
    this.valor = Number(this.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
